<template>
    <ul class="tree" :class="className">
        <li class="list-items" v-for="org in model" :key="org._id">
            <div class="item-title clearfix">
                <span class="name">
                    <i class="fa m-r-xs" :class="{'fa-plus-square-o': org.is_opened === -1,'fa-minus-square-o': org.is_opened === 1}" @click="org.is_opened = -org.is_opened" v-show="org.children.length > 0"></i>{{org.name}}</span>
                <span class="actions right">
                    <button class="btn btn-xs btn-primary" @click="add(org)" v-if="funcs.add === 1">添加</button>
                    <button class="btn btn-xs btn-info" @click="update(org)" v-if="funcs.update === 1">修改</button>
                    <button class="btn btn-xs btn-danger" @click="del(org)" :disabled="org.lock" v-show="org.children.length === 0" v-if="funcs.del === 1">删除</button>
                    <button class="btn btn-xs btn-primary" @click="qrcode(org)" v-if="funcs.qrcode === 1">二维码</button>
                    <input type="checkbox" v-model.number="org.is_selected" v-bind:true-value="1" v-bind:false-value="0" v-if="funcs.select === 1" @change="select(org)">
                </span>
            </div>
            <tree-view :model="org.children" v-if="org.children&&org.children.length >0" className="sub-tree" v-show="org.is_opened === 1" @add="add" @del="del" @update="update" :func="func" @select="select"  @qrcode="qrcode"></tree-view>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'tree-view',
    props: {
        model: {
            type: Array,
            default: function () {
                return []
            }
        },
        className: {
            type: String,
            default: function () {
                return ''
            }
        },
        func: {
            type: String,
            default: function () {
                return '1,2,3'
            }
        }
    },
    created: function () {
        const that = this
        that.func.split(',').forEach(f => {
            f = Number(f)
            if (!isNaN(f)) { // 数字
                switch (f) {
                    case 1:
                        that.funcs.add = 1;
                        break;
                    case 2:
                        that.funcs.update = 1;
                        break;
                    case 3:
                        that.funcs.del = 1;
                        break;
                    case 4:
                        that.funcs.select = 1;
                        break;
                    case 5:
                        that.funcs.qrcode = 1;
                        break;
                }
            }
        })
    },
    data: function () {
        return {
            funcs: {
                add: 0,
                update: 0,
                del: 0,
                select: 0
            }
        }
    },
    methods: {
        add: function (p) {
            const that = this
            that.$emit('add', p)
        },
        update: function (p) {
            const that = this
            that.$emit('update', p)
        },
        del: function (p) {
            const that = this
            that.$emit('del', p)
        },
        select: function (p) {
            const that = this
            that.$emit('select', p)
        },
        qrcode: function (p) {
            const that = this
            that.$emit('qrcode', p)
        }

    }
}
</script>



// WEBPACK FOOTER //
// tree.vue?a593f29e